import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const GIcon = (props) => (
  <SvgIcon viewBox="-297.7 388.1 13.4 18.7" {...props}>
    <g>
      <path d="M-284.8,396.7c0,1.4-0.2,2.7-0.7,3.7s-1.1,1.9-1.9,2.5l2.6,2l-1.7,1.5l-3.2-2.5c-0.4,0.1-0.9,0.1-1.4,0.1   c-1.2,0-2.3-0.3-3.3-0.9c-1-0.6-1.7-1.5-2.2-2.6c-0.5-1.1-0.8-2.4-0.8-3.8V396c0-1.5,0.3-2.8,0.8-3.9s1.3-2,2.2-2.6   c1-0.6,2-0.9,3.3-0.9c1.2,0,2.3,0.3,3.3,0.9c1,0.6,1.7,1.4,2.2,2.6c0.5,1.1,0.8,2.4,0.8,3.9V396.7z M-287.4,396c0-1.7-0.3-3-1-3.9   s-1.5-1.3-2.7-1.3c-1.1,0-2,0.4-2.7,1.3c-0.6,0.9-1,2.1-1,3.8v0.9c0,1.6,0.3,2.9,1,3.8c0.6,0.9,1.5,1.4,2.7,1.4   c1.2,0,2.1-0.4,2.7-1.3c0.6-0.9,0.9-2.2,0.9-3.9V396z" />
    </g>
  </SvgIcon>
);
export default GIcon;
